import { useState } from "react"
import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import { useGetMyOvertimesQuery } from "./api/overtimeApiSlice"
import OvertimesTable from "./views/OvertimesTable"
import MyOvertimesCalendar from "./components/MyOvertimesCalendar"

const MyOvertimes = () => {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    const [requestPage, setRequestPage] = useState(0)

    const changePage = (page) => {
        console.log("Requesting page" + page + "...")
        setRequestPage(page)
    }

    const {
        data: response,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetMyOvertimesQuery(requestPage)

    let content =
        <>
            {
                isSuccess &&
                <>
                    <MyOvertimesCalendar />
                    <OvertimesTable
                        items={response.content}
                        onPageChange={(number) => changePage(number - 1)}
                        itemsPerPage={response.pageable.pageSize}
                        totalItems={response.totalElements}
                        currentPage={requestPage + 1}

                    />
                </>
            }
        </>


    return <PageLayout
        pageTitle={t("absenceReport:menu.my_overtimes")}
        bodyContent={content}
        isLoadingPage={isLoading}
        isLoadingContent={isFetching}
        onPageRefresh={refetch}
    />

}

export default MyOvertimes